import Order from '../libs/order';
import utils from '../libs/utils';
import dateUtils from '../libs/date-util';

const makePreferredDate = () => [{ date: null, period: 0 }, { date: null, period: 0 }, { date: null, period: 0 }];
function isAllEqual(array) {
  if (array.length > 0) {
    return array.every(value => value === array[0]);
  }
  return true;
}
// 判断申请重新预约缴费申请人赴馆时间是否相同
function isInterviewDateSame(applicant) {
  // 获取第一申请人选择的项（固定时间、30天都有时间、30天都没时间）
  const applicantFirstDateChoice = applicant[0].interview.date_choice;
  if (applicant.every(item => item.interview.date_choice === applicantFirstDateChoice)) {
  // 获取所有人赴馆时间数组并对数组每一项的时间数组进行排序
    const interviewDateArray = applicant.map(item => item.interview.preferred_date.map(i => new Date(i.date)).sort(
      (a, b) => (a < b ? 1 : -1),
    ));
    // 数组第一个元素
    const interviewDateArrayFirst = interviewDateArray[0];
    // 如果数组每一项都与数组第一项相同则申请人赴馆时间相同
    // return interviewDateArray.every(item => item.every((i, index) => i === interviewDateArrayFirst[index]));
    // return interviewDateArray.every(item => item.every((i, index) => i.getTime() === interviewDateArrayFirst[index].getTime()));
    // 数组长度===0时，every返回true,即选择30天内均有时间item数组长度===0，直接返回true
    const isTimeSame = interviewDateArray.every(item => item.every((i, index) => i.getTime() === interviewDateArrayFirst[index].getTime()));

    // 赴馆城市数组
    const interviewCityArray = applicant.map(item => item.interview && item.interview.embassy_district_name);

    // 30天不能前往原因数组
    const dateOverReasonList = applicant.map(item => item.interview && item.interview.other_date);

    if (applicantFirstDateChoice === 2) {
      return isAllEqual(interviewCityArray) && isAllEqual(dateOverReasonList);
    }
    return isAllEqual(interviewCityArray) && isTimeSame;

  }
  return false;

}

const mixin = {
  computed: {
    cityDateEmpty() {
      return this.earlistDateData && this.earlistDateData.city_date && !this.earlistDateData.city_date.length;
    },
  },
  methods: {
    // 切换申请人预约相同/不同时间，重新初始化数据(已确认)
    switchInterviewTogether(value) {
      const order = this.dataModel;
      this.interviewFormDataErrorMap = order.applicant.map(() => ({
        0: [false, false, false],
        2: false,
      }));
      this.interviewformData = {
        user_order_id: order.user_order_id,
        interview_together: value,
        data: order.applicant.map(({ order_applicant_id }) => ({
          date_choice: 0,
          other_date: '',
          preferred_date: makePreferredDate(),
          order_applicant_id,
        })),
      };
    },

    // 重新预约缴费标签页展示：申请人预约相同时间合不同时间
    switchInterviewChangeTab() {
      const order = this.dataModel;
      this.interviewFormDataErrorMap = order.applicant.map(() => ({
        0: [false, false, false],
        2: false,
      }));
      const same = isInterviewDateSame(order.applicant);
      this.interviewformData = {
        user_order_id: order.user_order_id,
        interview_together: same ? 1 : 0,
        data: order.applicant.map(item => ({
          date_choice: item.interview.date_choice,
          other_date: item.interview.other_date,
          preferred_date: item.interview.preferred_date.length ? item.interview.preferred_date : makePreferredDate(),
          order_applicant_id: item.order_applicant_id,
          embassy_district_id: item.interview.embassy_district_id,
        })),
      };
    },

    // 获取最小可选日期
    getClosestDate() {
      const paddingDayNum = this.dataModel.need_delivery > 0 ? 2 : 4;
      return dateUtils.getClosestDate(paddingDayNum, this.holidays);
    },

    // 专门检查赴馆日期是否有过期(已确认)
    _checkInterviewDateIsOutDated() {
      const applicant = [];

      if (this.interviewSubmitted) {
        this.interviewformData.data.forEach((item, index) => {
          let applicantInterviewDateIsOutdated = false;

          let closestDateStr;
          if (this.earlistDateData && this.earlistDateData.city_date && this.earlistDateData.city_date.length) {
            const chooseItem = this.earlistDateData && this.earlistDateData.city_date.filter(city => city.embassy_district_id === item.embassy_district_id).pop();
            closestDateStr = chooseItem && chooseItem.earliest_date;
          } else {
            closestDateStr = this.earlistDateData && this.earlistDateData.default_date;
          }
          closestDateStr = new Date(closestDateStr).format('yyyy-MM-dd');

          if (item.date_choice === 0) {
            item.preferred_date.forEach((itm, idx) => {
              if (itm.date < closestDateStr || this.holidays.indexOf(itm.date) > -1) {
                applicantInterviewDateIsOutdated = true;
                this.interviewFormDataErrorMap[index][0][idx] = true;
              }
            });
            applicantInterviewDateIsOutdated && applicant.push(this.dataModel.applicant[index]);
          }
        });
      } else {
        this.dataModel.applicant.forEach((item, index) => {
          const { interview } = item;
          let applicantInterviewDateIsOutdated = false;

          let closestDateStr;
          if (this.earlistDateData && this.earlistDateData.city_date && this.earlistDateData.city_date.length) {
            const chooseItem = this.earlistDateData && this.earlistDateData.city_date.filter(city => city.embassy_district_id === interview.embassy_district_id).pop();
            closestDateStr = chooseItem && chooseItem.earliest_date;
          } else {
            closestDateStr = this.earlistDateData && this.earlistDateData.default_date;
          }
          closestDateStr = new Date(closestDateStr).format('yyyy-MM-dd');

          if (interview && interview.date_choice === 0) {
            interview.preferred_date.forEach((itm, idx) => {
              if (itm.date < closestDateStr || this.holidays.indexOf(itm.date) > -1) {
                applicantInterviewDateIsOutdated = true;
                this.interviewFormDataErrorMap[index][0][idx] = true;
              }
            });
            applicantInterviewDateIsOutdated && applicant.push(this.dataModel.applicant[index]);
          }
        });
      }
      const interviewDateIsOutdated = applicant.length >= 1;
      if (interviewDateIsOutdated) {
        this.prompt(this.interviewformData.interview_together, applicant);
      }
      return interviewDateIsOutdated;
    },

    // 提示过期(已确认)
    prompt(interviewTogether, applicant) {
      const self = this;

      if (interviewTogether) {
        utils.msgbox.alert(
          '上次选择的最佳赴馆日期已经过期了哦，请您重新选择',
          '重要提示', {
            confirmButtonText: '重新选择',
            callback: (action) => {
              if (action === 'confirm') {
                self.dataModel.order_status = Order.order_status = 10;
              }
            },
          },
        );
      } else {
        utils.msgbox.alert(
          `${applicant[0].applicant_name}${applicant.length === 1 ? '' : '等人'}的最佳赴馆日期已经过期了哦，请您重新选择`,
          '重要提示', {
            confirmButtonText: '重新选择',
            callback: (action) => {
              if (action === 'confirm') {
                self.dataModel.order_status = Order.order_status = 10;
              }
            },
          },
        );
      }
    },

    // 验证选择日期结果是否合法(已确认)
    validateInterviewDate() {
      // 先重新初始化错误map
      this.interviewFormDataErrorMap = this.interviewformData.data.map(() => ({
        0: [false, false, false],
        2: false,
      }));
      if (this.interviewformData.interview_together === 1) {
        const togetherData = this.interviewformData.data[0];
        this.interviewformData.data = this.interviewformData.data.map(({ order_applicant_id }) => utils.extend({}, togetherData, { order_applicant_id }));
      }
      let valid = true;
      this.interviewformData.data.forEach((item, index) => {
        if (!item.embassy_district_id && !this.cityDateEmpty) valid = false;
        if (item.date_choice === 0) {
          item.preferred_date.forEach((date, idx) => {
            if (!date.date) {
              valid = false;
              if (this.interviewSubmitted) {
                this.interviewFormDataErrorMap[index][0][idx] = true;
              }
            }
          });
        } else if (item.date_choice === 2) {
          if (item.other_date === '') {
            valid = false;
            if (this.interviewSubmitted) {
              this.interviewFormDataErrorMap[index][2] = true;
            }
          }
        }
      });
      return valid;
    },

    trimFormData() {
      this.interviewformData.data.forEach((item) => {
        if (item.date_choice === 0) {
          item.other_date = '';
        } else if (item.date_choice === 2) {
          item.preferred_date = [];
        } else if (item.date_choice === 1) {
          item.preferred_date = [];
          item.other_date = '';
        }
      });
    },

    // 处理放假和休息数组(已确认)
    handleHolidayArr() {
      const newArr = [];
      const fullArr = [];
      this.holidays.forEach((ele) => {
        if (new Date(ele).getDay() === 0 || new Date(ele).getDay() === 6) {
          fullArr.push({ date: ele, dayText: '休' });
          if (
            new Date(ele).getTime() <= new Date(this.disabledDate).getTime() &&
                        new Date(ele).getTime() >= new Date().getTime()
          ) {
            newArr.push({ date: ele, dayText: '休' });
          }
        } else {
          fullArr.push({ date: ele, dayText: '假' });
          if (
            new Date(ele).getTime() <= new Date(this.disabledDate).getTime() &&
                        new Date(ele).getTime() >= new Date().getTime()
          ) {
            newArr.push({ date: ele, dayText: '假' });
          }
        }
      });
      this.holidayArr = newArr;
      this.fullHoliday = fullArr;
    },
  },
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/interview.js